import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

import Panel from "@/components/ui/panel";
import HistoryPanelTrigger from "@/components/embedded-avatar/history-panel/history-panel-trigger";

import { ChatStore } from "@/stores/ChatStore";
import MessageItem from "./message-item";
import MessageInput from "./message-input";
import BlockbrainLoadingBubble from "./blockbrain-loading-bubble";

const HistoryPanel = () => {
  const { t } = useTranslation();
  const historyEndRef = useRef<HTMLDivElement>(null);
  const messages = ChatStore(state => state.messages);
  const isOpen = ChatStore(state => state.isHistoryPanelOpen);
  const setIsOpen = ChatStore(state => state.setIsHistoryPanelOpen);
  const isWaitingForBlockbrain = ChatStore(state => state.isWaitingForBlockbrain);

  // biome-ignore lint/correctness/useExhaustiveDependencies: we want to scroll to the bottom only when messages change
  useEffect(() => {
    if (historyEndRef.current) {
      // Use scrollIntoView with a block: 'nearest' to prevent parent window scrolling
      historyEndRef.current.scrollIntoView({ behavior: "smooth", block: 'nearest' });
    }
  }, [messages, isWaitingForBlockbrain]);
  return (
    <Panel
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={t("history.title")}
      trigger={() => <HistoryPanelTrigger />}
      containerId="avatar-container"
    >
      <div className={'flex h-full flex-col justify-between'}>
        {messages.length > 0 || isWaitingForBlockbrain ? (
          <div className="flex-1 min-h-0 space-y-4 overflow-y-auto">
            {messages.map((item, index) => (
              <MessageItem key={item.id} item={item} index={index} />
            ))}
            {isWaitingForBlockbrain && <BlockbrainLoadingBubble />}
            <div ref={historyEndRef} />
          </div>
        ) : (
          <p className="text-gray-500">{t("history.noHistory")}</p>
        )}
        <MessageInput />
      </div>
    </Panel>
  );
};

export default HistoryPanel;
